module.exports = __webpack_public_path__ + "img/flag-05.df4a8aac.svg";